const host = "https://bofo.me:3000/node/mortgagequotebackend";
export const registerRoute = `${host}/api/users/register`;
export const loginRoute = `${host}/api/users/login`;
